import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { WarmupPage } from "@/features/warmup/WarmupPage";

const search = z.object({
  view: z.enum(["mailboxes", "blocklists", "activity"]).optional(),
  peek: z.string().optional(),
});

export const Route = createFileRoute("/_app/outreach/warmup")({
  validateSearch: search,
  component: () => <WarmupPage search={Route.useSearch()} />,
});
